import { useSelector } from 'react-redux';
import { useState, useEffect, Fragment } from 'react';
import { useWeb3React } from '@web3-react/core';
import ReactCursorPosition from 'react-cursor-position';
import InfiniteScroll from 'react-infinite-scroll-component';
import { selectTokensUserOne } from '../../../../app/store';

// @ts-ignore
import verifyCheck from '../../../../icons/verifiy-check.svg';
import infoIcon from '../../../../icons/info-icon.svg';
import RefreshIcon from '../../../../icons/refresh-icon.svg';

import { TokenType } from '../../../../types/tokensType';

import TokenButton from '../TokenButton/TokenButton';

import { ERC721Item, ERC1155Item, ERC20Item } from '../../../../components/index';

import {
  SwapContent,
  SwapStepText,
  SwapSelectText,
  SwapButtonsWrapper,
  SwapItemsWrapper,
  SwapNoTokens,
  SearchWrapper,
  SearchImg,
  SwapInput,
  NothingsFound,
  InputAndSwitchWrapper,
  CheckBoxWrapper,
  CheckBoxLabel,
  CheckBox,
  VerifyIcon,
  InfoIconWrapper,
  InfoIcon,
  ToggleWrapper,
} from './SwapStepOne.styles';

import SearchIcon from '../../../../icons/search-icon.svg';
import { RefreshButton } from '../../../ViewTokens/ViewTokens';

type SwapStepOneProps = {
  buttons: any;
  allTokens: TokenType[];
  filterItems: Function;
  editAssets?: string;
  refresh: Function;
  next: () => void;
  isEnding: boolean;
  searchTerm: string;
  setSearchTerm: (search: string) => void;
};

const SwapStepOne = ({
  buttons,
  filterItems,
  allTokens,
  editAssets,
  refresh,
  isEnding,
  next,
  searchTerm,
  setSearchTerm,
}: SwapStepOneProps) => {
  const { chainId } = useWeb3React();
  const [filteredTokens, setFilteredTokens] = useState(allTokens);
  const [onlyVerified, setOnlyVerified] = useState(false);
  const [onlyNotSpam, setOnlyNotSpam] = useState(true);
  const swapTokens = useSelector(selectTokensUserOne);

  useEffect(() => {
    const arrWithSelectedTokens = allTokens.map((token: TokenType) => {
      for (let i = 0; i < swapTokens.length; i++) {
        if (swapTokens[i].tokenStandard === 'ERC-20') {
          if (swapTokens[i].title === token.title) {
            return {
              ...token,
              amount: swapTokens[i].amount!,
              isSelected: true,
            };
          }
        } else if (swapTokens[i].tokenStandard === 'ERC-20' && swapTokens[i].title === 'Ether') {
          if (swapTokens[i].tokenStandard === token.category) {
            return {
              ...token,
              amount: swapTokens[i].amount!,
              isSelected: true,
            };
          }
        } else if (swapTokens[i].address === token.address && swapTokens[i].id === token.id) {
          return {
            ...token,
            amount: swapTokens[i].amount!,
            isSelected: true,
          };
        }
      }

      return token;
    });

    setFilteredTokens(arrWithSelectedTokens);
  }, [allTokens, swapTokens]);

  return (
    <SwapContent>
      {!editAssets ? (
        <>
          {' '}
          <SwapStepText>Step 1 of 3</SwapStepText>
          <SwapSelectText>Select The NFTs and Tokens You Want To Swap</SwapSelectText>
        </>
      ) : (
        <SwapSelectText>Edit Your NFTs, ERC-20 or Native Token to Swap</SwapSelectText>
      )}
      <SwapButtonsWrapper>
        {buttons
          .slice(0)
          .reverse()
          .map((button: any) => (
            <TokenButton
              key={button.name}
              token={button.name}
              isSelected={button.isSelected}
              filter={filterItems}
              clearSearch={setSearchTerm}
            />
          ))}
        <RefreshButton src={RefreshIcon} onClick={() => refresh()} alt="refresh button" />
      </SwapButtonsWrapper>
      <InputAndSwitchWrapper>
        <SearchWrapper>
          <SearchImg src={SearchIcon} />
          <SwapInput
            type="text"
            placeholder="Filter assets"
            value={searchTerm}
            onChange={(event: any) => {
              setSearchTerm(event.target.value);
            }}
          />
        </SearchWrapper>

        <ToggleWrapper>
          <CheckBoxWrapper>
            <CheckBox id="checkbox-verified" type="checkbox" onClick={() => setOnlyVerified(!onlyVerified)} />
            <CheckBoxLabel htmlFor="checkbox-verified" />
          </CheckBoxWrapper>
          <VerifyIcon src={verifyCheck} />
          <SwapStepText>Verified Only</SwapStepText>
          <InfoIconWrapper>
            <InfoIcon src={infoIcon} />
            <div className="helpModal">
              <span>When active, only verified (tradeable) assets are visible</span>
            </div>
          </InfoIconWrapper>
        </ToggleWrapper>

        {chainId !== 42 && (
          <ToggleWrapper>
            <CheckBoxWrapper>
              <CheckBox
                checked={onlyNotSpam}
                id="checkbox-spam"
                type="checkbox"
                onClick={() => {
                  setOnlyNotSpam(!onlyNotSpam);
                }}
              />
              <CheckBoxLabel htmlFor="checkbox-spam" />
            </CheckBoxWrapper>
            <SwapStepText>Hide Spam</SwapStepText>
          </ToggleWrapper>
        )}
      </InputAndSwitchWrapper>
      {!allTokens.length ? (
        <SwapNoTokens>You don't have tokens of this type</SwapNoTokens>
      ) : (
        <InfiniteScroll
          dataLength={filteredTokens.length}
          hasMore={!isEnding}
          loader={!isEnding && <h1>Loading...</h1>}
          next={next}
          style={{ overflow: 'visible' }}
        >
          <SwapItemsWrapper>
            <NothingsFound>Nothing's found</NothingsFound>
            {filteredTokens
              .filter((token) => {
                if (onlyVerified) {
                  return token.isWhitelisted;
                }
                if (onlyNotSpam) {
                  return !token.isSpam;
                }
                return token;
              })
              .filter((token) => {
                if (searchTerm === '') return token;
                if (token.category === 'Tokens') {
                  if (!token.title) {
                    return token;
                  }
                  if (
                    token.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    token.title.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return token;
                  }
                } else if (!token.title && token.tokenName) {
                  if (
                    token.tokenName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    token.tokenName.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return token;
                  }
                } else if (!token.tokenName && token.title) {
                  if (
                    token.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    token.title.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return token;
                  }
                } else if (token.title && token.tokenName) {
                  if (
                    token.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    token.title.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return token;
                  }

                  if (
                    token.tokenName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    token.tokenName.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return token;
                  }
                }

                return null;
              })
              .map((token: TokenType) => {
                switch (token.category) {
                  case 'NFT':
                    return (
                      <Fragment key={token.uniqueKey}>
                        {token.tokenStandard === 'ERC-721' ? (
                          <ReactCursorPosition>
                            <ERC721Item
                              key={token.uniqueKey}
                              id={token.id!}
                              image={token.image}
                              imageFallback={token.imageFallback}
                              title={token.title}
                              tokenName={token.tokenName}
                              balance={token.balance!}
                              isSelected={token.isSelected!}
                              amount={token.amount!}
                              address={token.address}
                              description={token.description}
                              isWhitelisted={token.isWhitelisted}
                            />
                          </ReactCursorPosition>
                        ) : (
                          <ReactCursorPosition>
                            <ERC1155Item
                              key={token.uniqueKey}
                              image={token.image}
                              imageFallback={token.imageFallback}
                              title={token.title}
                              tokenName={token.tokenName}
                              isSelected={token.isSelected!}
                              balance={token.balance!}
                              id={token.id!}
                              amount={token.amount!}
                              address={token.address}
                              description={token.description}
                              isWhitelisted={token.isWhitelisted}
                            />
                          </ReactCursorPosition>
                        )}
                      </Fragment>
                    );
                  case 'Tokens':
                    return (
                      <Fragment key={token.uniqueKey}>
                        {token.tokenStandard === 'ERC-20' ? (
                          <ERC20Item
                            key={token.uniqueKey}
                            image={token.image}
                            title={token.title}
                            balance={token.balance!}
                            symbol={token.symbol}
                            decimals={token.decimals}
                            id={token.id!}
                            isSelected={token.isSelected!}
                            amount={token.amount!}
                            address={token.address}
                            isWhitelisted={token.isWhitelisted}
                          />
                        ) : (
                          <></>
                        )}
                      </Fragment>
                    );
                  default:
                    return null;
                }
              })}
          </SwapItemsWrapper>
        </InfiniteScroll>
      )}
    </SwapContent>
  );
};

export default SwapStepOne;
